import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { FaHome, FaListAlt, FaUserAlt, FaDownload } from "react-icons/fa";
import { FiShoppingCart } from "react-icons/fi";
import { IoClose, IoMenu } from "react-icons/io5";

const NavbarScreen = () => {
  const location = useLocation();
  const [activeTab, setActiveTab] = useState("/");
  const [menuOpen, setMenuOpen] = useState(false);
  const [profileOpen, setProfileOpen] = useState(false);
  const [role, setRole] = useState("");

  useEffect(() => {
    const path = location.pathname;
    const newRole = path.includes("/product/reseller") ? "reseller" : "home";
    localStorage.setItem("role", newRole);
    setRole(newRole);
  }, [location.pathname]);

  const navItems = [
    ...(role == "home"
      ? [
        { name: "Home", to: "/", icon: <FaHome /> },
        {
          name: "All Products",
          to: "/AllProductData",
          icon: <FaListAlt />,
        },
      ]
      : []),

    { name: "Cart", to: "/cart", icon: <FiShoppingCart /> },
  ];

  useEffect(() => {
    setActiveTab(location.pathname);
  }, [location]);

  return (
    <header className="sticky top-0 z-50 bg-white shadow-sm">
      <div className="flex items-center justify-between px-4 py-3">
        <Link to="/">
          <img
            src={require("../../assets/Logo.png")}
            className="w-20 h-auto"
            alt="logo"
          />
        </Link>

        <nav className="hidden md:flex space-x-8 items-center">
          {navItems.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              className={`flex items-center gap-2 font-medium transition 
                ${activeTab === item.to ? "text-red-600" : "text-gray-700"}
                hover:text-red-600`}
            >
              <span className="text-xl">{item.icon}</span>
              {item.name}
            </Link>
          ))}

          <div className="relative">
            <button
              onClick={() => setProfileOpen(!profileOpen)}
              className="flex items-center gap-2 text-gray-700 hover:text-red-600 transition"
            >
              <FaUserAlt className="text-xl" />
              Profile
            </button>

            {profileOpen && (
              <ul className="absolute right-0 mt-2 w-48 bg-white shadow-lg rounded-md py-2">
                <li>
                  <Link
                    to={"/my-account/"}
                    className="block px-4 py-2 hover:bg-gray-100"
                    onClick={() => setProfileOpen(false)}
                  >
                    My Profile
                  </Link>
                </li>

                <li>
                  <Link
                    to="/track-your-order/"
                    className="block px-4 py-2 hover:bg-gray-100"
                    onClick={() => setProfileOpen(false)}
                  >
                    Track Orders
                  </Link>
                </li>

                {role == "home" && (
                  <li>
                    <Link
                      to="/offers"
                      className="block px-4 py-2 hover:bg-gray-100"
                      onClick={() => setProfileOpen(false)}
                    >
                      Offers
                    </Link>
                  </li>
                )}

                <li>
                  <button
                    className="w-full text-left px-4 py-2 hover:bg-gray-100"
                    onClick={() => setProfileOpen(false)}
                  >
                    Logout
                  </button>
                </li>
              </ul>
            )}
          </div>

          {/* Download App */}
          <a
            href="https://play.google.com/store/apps/details?id=com.bharatcod"
            className="bg-red-600 text-white px-4 py-2 rounded-md shadow hover:bg-red-700 transition flex items-center gap-2"
          >
            <FaDownload />
            Download App
          </a>
        </nav>

        {/* Mobile Menu Button */}
        <button
          className="md:hidden text-3xl"
          onClick={() => setMenuOpen(true)}
        >
          <IoMenu />
        </button>
      </div>

      {/* Mobile Drawer */}
      {menuOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-40 z-50">
          <div className="absolute left-0 top-0 w-64 h-full bg-white shadow-lg p-4">
            {/* Close Button */}
            <button
              className="text-3xl mb-4"
              onClick={() => setMenuOpen(false)}
            >
              <IoClose />
            </button>

            {/* Menu List */}
            <ul className="space-y-4 text-lg">
              {navItems.map((item) => (
                <li key={item.to}>
                  <Link
                    to={item.to}
                    className={`flex items-center gap-2 
                      ${activeTab === item.to ? "text-red-600" : "text-gray-700"}
                      hover:text-red-600`}
                    onClick={() => setMenuOpen(false)}
                  >
                    <span className="text-xl">{item.icon}</span>
                    {item.name}
                  </Link>
                </li>
              ))}

              {/* Profile */}
              <li>
                <Link
                  to="/Profile"
                  onClick={() => setMenuOpen(false)}
                  className="flex gap-2 hover:text-red-600"
                >
                  <FaUserAlt /> Profile
                </Link>
              </li>

              <li>
                <Link
                  to="/about-us/"
                  className="hover:text-red-600"
                  onClick={() => setMenuOpen(false)}
                >
                  About Us
                </Link>
              </li>

              <li>
                <Link
                  to="/contact-us/"
                  className="hover:text-red-600"
                  onClick={() => setMenuOpen(false)}
                >
                  Contact Us
                </Link>
              </li>

              <li>
                <Link
                  to="/offers"
                  className="hover:text-red-600"
                  onClick={() => setMenuOpen(false)}
                >
                  Offers
                </Link>
              </li>
            </ul>
          </div>
        </div>
      )}
    </header>
  );
};

export default NavbarScreen;
